import React, { useState } from "react";
import AltaInventario from "./altaInventario";
import AltaSobrante from "./altaSobrante";
import AltaFaltante from "./altaFaltante";

function AltasTransitos() {
  const [tipoAlta, setTipoAlta] = useState("");

  return (
    <>
      <div className="container-fluid d-flex justify-content-center align-items-center">
        <div className="w-100">
          <div className="mb-4 d-flex justify-content-center">
            <div className="d-flex align-items-center gap-4">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAlta"
                  id="altaInventario"
                  value="inventario"
                  onChange={(e) => setTipoAlta(e.target.value)}
                />
                <label className="form-check-label" htmlFor="altaInventario">
                  Alta inventario
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAlta"
                  id="altaSobrante"
                  value="sobrante"
                  onChange={(e) => setTipoAlta(e.target.value)}
                />
                <label className="form-check-label" htmlFor="altaSobrante">
                  Alta sobrante
                </label>
              </div>

              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="tipoAlta"
                  id="altaFaltante"
                  value="faltante"
                  onChange={(e) => setTipoAlta(e.target.value)}
                />
                <label className="form-check-label" htmlFor="altaFaltante">
                  Alta faltante
                </label>
              </div>
            </div>
          </div>

          {/* Renderizado condicional */}
          {tipoAlta === "inventario" && <AltaInventario />}
          {tipoAlta === "sobrante" && <AltaSobrante />}
          {tipoAlta === "faltante" && <AltaFaltante />}
        </div>
      </div>
    </>
  );
}

export default AltasTransitos;
